class ItemForBillingList {
    id = null;
    invoice_item_type_id = null;
    details = null;
    placement_id = null;
    seafarer_id = null;
    rank_id = null;
    seniority = null;
    maritime_object_id = null;
    invoice_to_id = null;
    timesheet_item_id = null;
    expense_id = null;
    quantity = null;
    rate = null;
    sum = null;
    date_from = null;
    date_to = null;
    invoice = false;
    payslip = false;
    currency_id = null;
    file = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    files = [];
    po_number = null;
    item_id = null;
    vat_percentage = null;
    billing_list_id = null;
    position = null;
    additional = null;
    total_with_vat = null;
    gdpr_edit_lock = false;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default ItemForBillingList;
